import axios from "../../../config/axiosConfig";

export const getReporteTipoBanco = ({ sucursal, year, mes }) =>
  axios.get("/api/reporte-pagos/tipo-banco", { params: { sucursal, year, mes } });

export const getReporteMensualPorBanco = ({ sucursal, year, tipoIngreso }) =>
  axios.get("/api/reporte-pagos/mensual-por-banco", { params: { sucursal, year, tipoIngreso } });

export const getDetalleCobros = ({ sucursal, year, mes, banco }) =>
  axios.get("/api/reporte-pagos/detalle-cobros", { params: { sucursal, year, mes, banco } });

export const exportarDetalleCobros = ({ sucursal, year, mes, banco }) =>
  axios.get("/api/reporte-pagos/detalle-cobros/exportar", {
    params: { sucursal, year, mes, banco },
    responseType: "blob",
  });

export const getBancosActivos = () => axios.get("/api/reporte-pagos/bancos");

export const getReportePorServicio = ({ sucursal, year, mes }) =>
  axios.get("/api/reporte-pagos/por-servicio", { params: { sucursal, year, mes } });

export const getReporteMensualPorServicio = ({ sucursal, year }) =>
  axios.get("/api/reporte-pagos/mensual-por-servicio", { params: { sucursal, year } });

export const getDetalleTipoIngreso = ({ sucursal, year, mes, tipoIngreso }) =>
  axios.get("/api/reporte-pagos/detalle-tipo-ingreso", { params: { sucursal, year, mes, tipoIngreso } });
